import React from 'react';

const RetryIcon = () => {
	return (
		<svg
			width='15'
			height='12'
			viewBox='0 0 15 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M3.49911 6.00035C3.49953 4.9197 3.85004 3.86828 4.49815 3.00356C5.14626 2.13883 6.05708 1.50736 7.09419 1.20371C8.1313 0.900069 9.23887 0.9406 10.251 1.31924C11.2631 1.69787 12.1254 2.39423 12.7085 3.30401C13.2917 4.21379 13.5644 5.28803 13.4859 6.36581C13.4073 7.44359 12.9817 8.46692 12.2727 9.2825C11.5638 10.0981 10.6097 10.662 9.55331 10.8899C8.49695 11.1177 7.39522 10.9972 6.41311 10.5463C6.2937 10.4973 6.15995 10.4963 6.03983 10.5436C5.91972 10.5909 5.82255 10.6828 5.76868 10.8001C5.7148 10.9175 5.70838 11.0511 5.75078 11.173C5.79317 11.2949 5.88108 11.3958 5.99611 11.4543C7.1747 11.9953 8.49684 12.1399 9.76449 11.8664C11.0321 11.5929 12.1771 10.9161 13.0278 9.93727C13.8785 8.95847 14.3891 7.73039 14.4833 6.43699C14.5774 5.14359 14.25 3.85451 13.55 2.76282C12.8501 1.67113 11.8152 0.835609 10.6006 0.381411C9.38587 -0.0727882 8.05673 -0.121216 6.81222 0.243382C5.56771 0.607981 4.47482 1.36598 3.69726 2.40383C2.9197 3.44169 2.49933 4.70353 2.49911 6.00035H3.49911Z'
				fill='#05386B'
			/>
			<path
				d='M4.96511 6.00035H1.03311C0.985606 6.00037 0.939091 6.01392 0.899011 6.03942C0.858931 6.06491 0.826945 6.10131 0.806799 6.14432C0.786653 6.18735 0.779181 6.23521 0.785257 6.28233C0.791334 6.32944 0.810707 6.37385 0.84111 6.41035L2.80711 8.77035C2.83057 8.79848 2.85993 8.82112 2.89311 8.83665C2.92629 8.85219 2.96248 8.86024 2.99911 8.86024C3.03574 8.86024 3.07193 8.85219 3.10511 8.83665C3.13829 8.82112 3.16765 8.79848 3.19111 8.77035L5.15711 6.41035C5.18751 6.37385 5.20689 6.32944 5.21296 6.28233C5.21904 6.23521 5.21157 6.18735 5.19142 6.14432C5.17127 6.10131 5.13929 6.06491 5.09921 6.03942C5.05913 6.01392 5.01261 6.00037 4.96511 6.00035Z'
				fill='#05386B'
			/>
		</svg>
	);
};

export default RetryIcon;
